/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CallClearCart, chain } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToChainBefore(chain, CallClearCart, props => {
    // Add tracking before remove the cart line
    const cart = getCurrentCartState(props.getState()).value;
    const cartLinesObject: any[] = [];
    if (cart && cart?.cartLines) {
        try {
            const dataLayer = (window as any).dataLayer  || [];
            dataLayer.push({ ecommerce: null });
            cart?.cartLines.forEach((cartLine: CartLineModel, idx) => {
                cartLinesObject.push({
                    id: cartLine?.erpNumber,
                    name: cartLine?.shortDescription,
                    price: cartLine?.pricing?.actualPrice,
                    quantity: cartLine?.qtyOrdered,
                    category:cartLine?.properties?.cartlineCategoryName
                });
            });
            if (dataLayer) {
                dataLayer.push({
                    event: "removeFromCart",
                    ecommerce: {
                        remove: {
                            actionField: { list: "Category Results", action: "remove" },
                            products: cartLinesObject,
                        },
                    },
                });
            }
            
        } catch (err) {
            // eslint-disable-next-line no-console
            logger.debug(err);
        }
    }
});
